export const environment = {
  production: true,
  buildId: '3274540090921071',
  configFile: 'config.json',
};
